import { useState, useRef, useEffect } from 'react'

// Canonical agent names (matches CoSelect feature). Hardcoded because they're stable.
const CANONICAL_AGENTS = ['Giancarlo', 'Lisette', 'Nicolás', 'Daniel', 'Jorge', 'Iván']

// Agentes administrativos (buckets de sistema). Se filtran por wassenger_asignado_a igual que los vendedores.
const ADMIN_AGENTS = ['ASIGNABLES', 'NO RESPONDEN', 'RESPUESTA PENDIENTE', 'Ninguno']

function AgentRow({ name, active, onSelect }) {
  return (
    <button
      onClick={() => onSelect(name)}
      type="button"
      className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 ${active ? 'bg-blue-50 dark:bg-blue-900/30 font-medium' : ''}`}
    >
      {name}
    </button>
  )
}

/**
 * Chip azul de filtro por agente. Solo admin lo ve (gating en AddFilterDropdown).
 * @param {Object} filters - { agent }
 * @param {Function} updateFilter - (key, value) => void
 * @param {boolean} autoOpen - abrir el dropdown al montar
 * @param {Function} onRemove - () => void
 */
export default function AgentFilterChip({ filters, updateFilter, autoOpen = false, onRemove }) {
  const [open, setOpen] = useState(!!autoOpen)
  const ref = useRef(null)

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [])

  const handleRemove = (e) => {
    e.stopPropagation()
    if (onRemove) onRemove()
  }

  const handleSelect = (name) => {
    updateFilter('agent', name)
    setOpen(false)
  }

  const label = filters.agent ? `👤 ${filters.agent}` : '👤 Agente (elegir)'

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(o => !o)}
        type="button"
        className="group flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-200 hover:bg-blue-200 dark:hover:bg-blue-900/60 transition-colors"
      >
        <span>{label}</span>
        <span
          onClick={handleRemove}
          className="opacity-0 group-hover:opacity-100 transition-opacity ml-1 cursor-pointer"
          role="button"
        >
          ✕
        </span>
      </button>
      {open && (
        <div className="absolute left-0 top-full mt-1 w-48 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50 overflow-hidden max-h-80 overflow-y-auto">
          {CANONICAL_AGENTS.map(name => (
            <AgentRow key={name} name={name} active={filters.agent === name} onSelect={handleSelect} />
          ))}
          <div className="px-3 py-1 text-[10px] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500 bg-gray-50 dark:bg-gray-900/40 border-t border-gray-100 dark:border-gray-700">Administrativos</div>
          {ADMIN_AGENTS.map(name => (
            <AgentRow key={name} name={name} active={filters.agent === name} onSelect={handleSelect} />
          ))}
        </div>
      )}
    </div>
  )
}
